module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAbwAAAG8B8aLcQwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABmSURBVDiNrZNBDsAgCAQn/Sn+ro/wZ03oxUtNEHRr4kWcRVYAuAFzd3Y2YIPFgAdoG3AbjM0Hqch8NwxU4I9AJhLFallWwtlTs9IqZi19uVDX7yVIJkrfKDVSBQ5bGXWYgM75OPcXAQ4DVYugiIgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icons/close.png
// module id = 6BIE
// module chunks = 0